import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'antd';
import { getDomainList } from 'redux/slices/domainSlice';
import { resetPasswordStatus, resetUserPassword } from 'redux/slices/resetPassword';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { LockIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { InputWrap, StyledInputPassword, ThemeLoginButton } from 'pages/login/login_style';
import LoginButtonLoader from 'component/loader_component/loginButtonLoader';

export default function ResetPasswordComponent({ theme }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [linkStatus, setLinkStatus] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const { brandingData } = useSelector((state) => state.themes);
  // Retrieve the query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const fqdn = queryParams.get('fqdn');
  const id = queryParams.get('id');
  const domainId = queryParams.get('DomainId');
  const src = queryParams.get('src');

  useEffect(() => {
    if (brandingData) {
      dispatch(getDomainList(brandingData.url));
    }
  }, [brandingData]);

  useEffect(() => {
    if (![3, 4].includes(queryParams.size)) {
      navigate('/');
    }
  }, [queryParams]);

  // Custom validator to check if the passwords match
  const validatePasswordMatch = async (_, value) => {
    const newPassword = form.getFieldValue('strNewPassword');
    if (newPassword && value === newPassword) {
      setPasswordMatch(true);
      return Promise.resolve();
    } else {
      setPasswordMatch(false);
      throw new Error('Passwords do not match');
    }
  };
  useEffect(() => {
    if (id) {
      const passwordStatus = async () => {
        const statusValue = await dispatch(resetPasswordStatus(id));
        if (statusValue?.payload.data?.isExpired) {
          setLinkStatus(true);
        }
      };
      passwordStatus();
    }
  }, [id]);

  const onFinish = async (value) => {
    const values = {
      strNewPassword: value.strNewPassword,
      fqdn,
      id,
      domainId,
    };
    try {
      setLoading(true);
      const sweetAlert = await dispatch(resetUserPassword(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        if (src) {
          window.location.href = src;
        } else {
          navigate('/login');
        }
      } else if (sweetAlert?.payload.status === 400) {
        await SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='reset-content-component'>
      {linkStatus ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '400px',
            color: '#cbcbcb',
            height: '100px',
          }}
          className='reset-linkexpiry-wrap'
        >
          <h1 className='reset-linkexpiry-content'>The Reset Password Link Expired.</h1>
        </div>
      ) : (
        <Form name='register' onFinish={onFinish} form={form} scrollToFirstError className='reset-form-element'>
          <InputWrap className='reset-input-wrapper'>
            <Form.Item
              name='strNewPassword'
              rules={[{ required: true, message: 'Please enter the Password.' }]}
              className='reset-form-item-newPass'
            >
              <StyledInputPassword
                className={`${theme} reset-input-newPass`}
                size='large'
                prefix={<LockIcon className='icon-color' />}
                placeholder='New Password'
              />
            </Form.Item>
            <Form.Item
              name='confirm_password'
              dependencies={['strNewPassword']}
              rules={[
                { required: true, message: 'Please Confirm the Password.' },
                { validator: validatePasswordMatch },
              ]}
              className='reset-form-item-confirmPass'
            >
              <StyledInputPassword
                className={`${theme} reset-input-confirmPass`}
                size='large'
                prefix={<LockIcon className='icon-color' />}
                placeholder='Confirm Password'
              />
            </Form.Item>
            <Form.Item className='reset-form-item-submit'>
              <ThemeLoginButton
                className={`${theme} reset-submit-button`}
                type='primary'
                disabled={!passwordMatch || loading}
              >
                {loading ? <LoginButtonLoader /> : 'Reset Password'}
              </ThemeLoginButton>
            </Form.Item>
          </InputWrap>
        </Form>
      )}
    </div>
  );
}
